export default __webpack_public_path__ + "static/media/14.70bc695c.wav";